"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = void 0;
var GameConstants_1 = require("../../../GameConstants");
var BoardContainer_1 = require("./BoardContainer");
var GameVars_1 = require("../../../GameVars");
var GameManager_1 = require("../../../GameManager");
var AudioManager_1 = require("../../../AudioManager");
var Item = /** @class */ (function (_super) {
    __extends(Item, _super);
    function Item(scene, i) {
        var _this = _super.call(this, scene) || this;
        _this.i = i;
        _this.selected = false;
        _this.cell = null;
        _this.f = 0;
        _this.activated = false;
        var textureAtlas;
        var textureName;
        if (GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1) {
            textureAtlas = "texture_atlas_2";
            textureName = "cake_" + _this.i;
        }
        else {
            textureAtlas = "texture_atlas_3";
            textureName = "biscuits_" + _this.i;
        }
        _this.itemImage = new Phaser.GameObjects.Image(_this.scene, 0, 0, textureAtlas, textureName);
        _this.itemImage.setScale(Item.ITEM_SCALE);
        _this.add(_this.itemImage);
        if (GameConstants_1.GameConstants.SHOW_DEBUG_GEOMETRY) {
            _this.drawDebugGeometry();
        }
        _this.creationTick = Math.floor(Math.random() * 180);
        return _this;
    }
    Item.prototype.update = function () {
        if (!this.activated) {
            this.f++;
            if (this.f === 20) {
                this.activated = true;
                this.itemImage.setInteractive({ useHandCursor: true, pixelPerfect: false });
                this.itemImage.input.hitArea.setTo(-20, -20, this.itemImage.width + 40, this.itemImage.height + 40);
                this.itemImage.on("pointerdown", this.onDownItemImage, this);
            }
        }
        if (this.selected) {
            var x = (this.scene.input.activePointer.x - this.parentContainer.x) / this.parentContainer.scaleX;
            var y = (this.scene.input.activePointer.y - this.parentContainer.y) / this.parentContainer.scaleY;
            this.x += (x - this.x) * .25;
            this.y += (y - this.y) * .25;
            var pointer = this.scene.input.activePointer;
            if (!pointer.isDown) {
                this.onUpItemImage();
            }
            GameManager_1.GameManager.updateLastPlayerAction();
        }
    };
    Item.prototype.onCoinsEmitted = function () {
        this.scene.tweens.add({
            targets: this.itemImage,
            scaleX: 1.065 * Item.ITEM_SCALE,
            scaleY: .935 * Item.ITEM_SCALE,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 150,
            yoyo: true
        });
        AudioManager_1.AudioManager.playSound("coin_emmited");
    };
    Item.prototype.forceUpgrade = function () {
        this.i++;
        GameVars_1.GameVars.modeGameData.boardConfiguration[this.cell.p.r][this.cell.p.c].n++;
        var textureName;
        if (GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1) {
            textureName = "cake_" + this.i;
        }
        else {
            textureName = "biscuits_" + this.i;
        }
        this.itemImage.setFrame(textureName);
        this.itemImage.input.hitArea.setTo(-20, -20, this.itemImage.width + 40, this.itemImage.height + 40);
    };
    Item.prototype.merged = function () {
        this.i++;
        var textureName;
        if (GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1) {
            textureName = "cake_" + this.i;
        }
        else {
            textureName = "biscuits_" + this.i;
        }
        this.scene.time.delayedCall(300, function () {
            this.itemImage.setFrame(textureName);
            this.itemImage.input.hitArea.setTo(-20, -20, this.itemImage.width + 40, this.itemImage.height + 40);
        }, [], this);
        var now = this.scene.time.now;
        if (now - Item.timeLastMerge < 2250) {
            if (Item.mergeAudioEffectRate < 2) {
                Item.mergeAudioEffectRate += .5;
                AudioManager_1.AudioManager.playSound("merge", false, 1, Item.mergeAudioEffectRate);
            }
            else {
                AudioManager_1.AudioManager.playSound("merge_final");
            }
        }
        else {
            Item.mergeAudioEffectRate = 1;
            AudioManager_1.AudioManager.playSound("merge");
        }
        Item.timeLastMerge = now;
    };
    Item.prototype.swapItem = function (i) {
        this.i = i;
        var textureName;
        if (GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1) {
            textureName = "cake_" + this.i;
        }
        else {
            textureName = "biscuits_" + this.i;
        }
        this.itemImage.setFrame(textureName);
        this.itemImage.input.hitArea.setTo(-20, -20, this.itemImage.width + 40, this.itemImage.height + 40);
    };
    Item.prototype.onDownItemImage = function () {
        if ((GameVars_1.GameVars.paused || GameVars_1.GameVars.carouselActive) && GameVars_1.GameVars.gameData.tutorialPhase !== 3) {
            return;
        }
        this.selected = true;
        BoardContainer_1.BoardContainer.currentInstance.onItemPicked(this);
    };
    Item.prototype.onUpItemImage = function () {
        if ((GameVars_1.GameVars.paused || GameVars_1.GameVars.carouselActive) && GameVars_1.GameVars.gameData.tutorialPhase !== 3) {
            return;
        }
        this.selected = false;
        BoardContainer_1.BoardContainer.currentInstance.onItemReleased(this);
    };
    Item.prototype.drawDebugGeometry = function () {
        var debugGraphics = new Phaser.GameObjects.Graphics(this.scene);
        debugGraphics.fillStyle(0xFF0000);
        debugGraphics.fillPoint(0, 0, 8);
        this.add(debugGraphics);
    };
    Item.ITEM_SCALE = .5;
    Item.timeLastMerge = 0;
    Item.mergeAudioEffectRate = 1;
    return Item;
}(Phaser.GameObjects.Container));
exports.Item = Item;
